<template>
  <div class="consulta-clientes">
    <g-card class="card-consulta-clientes" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Consultar Clientes </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limparFiltro"
            />
            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="Grid()"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="consulta-clientes-conteudo espacamento-filtros">
          <div class="campo-unidade">
            <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
            <PDropDown
            class="input-label unidade"
            placeholder="TODAS"
            optionLabel="nome"
            optionValue="id"
            :options="EmpresaArray"
            v-model="objFiltro.UnidadeId"
            >
            </PDropDown>
          </div>

          <div class="cnpj">
            <div class="cnpj-titulo titulo-conteudo-filtros"> CNPJ </div>
            <PInputText
            class="cnpj-input input-label"
            placeholder="Insira o CNPJ do cliente"
            optionLabel="text"
            optionValue="value"
            :options="cnpj"
            v-model="objFiltro.cnpj"
            v-mask="'##.###.###/####-##'" 
            unmask
            />
          </div>

          <div class="codigo-cliente">
            <div class="codigo-cliente-titulo titulo-conteudo-filtros"> Código </div>
            <PInputText
            class="codigo-cliente-input input-label"
            placeholder="Insira o código do cliente"
            optionLabel="text"
            optionValue="value"
            :options="codigo"
            v-model="objFiltro.codigo"
            />
          </div>

          <div class="razao-social">
            <div class="razao-social-titulo titulo-conteudo-filtros"> Razão Social </div>
            <PInputText
            class="razao-social-input input-label"
            placeholder="Insira a Razão Social do cliente"
            optionLabel="text"
            optionValue="value"
            :options="razaoSocial"
            v-model="objFiltro.razaoSocial"
            />
          </div>

          <div class="nome-reduzido">
            <div class="nome-reduzido-titulo titulo-conteudo-filtros"> Nome reduzido </div>
            <PInputText
            class="nome-reduzido-input input-label"
            placeholder="Insira o nome reduzido"
            optionLabel="text"
            optionValue="value"
            :options="nomeFantasia"
            v-model="objFiltro.nomeFantasia"
            />
          </div>

          <div class="estado-cidade">
            <div class="estado">
              <div class="estado-titulo titulo-conteudo-filtros"> UF </div>
              <PDropDown
              class="estado-input input-label"
              placeholder="UF"
              optionValue="id"
              optionLabel="siglaEstado"
              :options="EstadoArray"
              v-model="objFiltro.EstadoId"
              :filter="true"
              @change="buscarcidade"
              />
            </div>

            <div class="cidade">
              <div class="cidade-titulo titulo-conteudo-filtros"> Cidade </div>
              <PDropDown
              class="cidade-input input-label"
              placeholder="Cidade"
              optionValue="id"
              optionLabel="nomeCidade"
              :options="CidadeArray"
              v-model="objFiltro.CidadeId"
              :filter="true"
              @change="setCidade"
              @filter="buscarCidadeSemEstado($event.value)"
              />
            </div>
          </div>

          <div class="data-cadastro">
            <div class="data-cadastro-titulo titulo-conteudo-filtros"> Data de Cadastro </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="data-cadastro-inicio-input input-label"
                placeholderinput="Início"
                alturainput="45px"
                largurainput="100%"
                tamanhobotao="35px"
                invertido
                retornaDateTime
                permiteDataPassadas
                dataPassadas
                v-model="objFiltro.DataCadastroInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                class="data-cadastro-termino-input input-label"
                placeholderinput="Término"
                alturainput="45px"
                largurainput="100%"
                tamanhobotao="35px"
                invertido
                retornaDateTime
                permiteDataPassadas
                dataPassadas
                v-model="objFiltro.DataCadastroFim"
                ></g-date-input>
              </div>
            </div>
          </div>

          <div class="situacao">
            <div class="situacao-titulo titulo-conteudo-filtros"> Situacao </div>
            <PDropDown
            class="situacao-input input-label"
            :filter="true"
            optionLabel="text"
            optionValue="value"
            :options="SituacaoArray"
            v-model="objFiltro.Situacao"
            placeholder="Selecione"
            >
            </PDropDown>
          </div>

          <div class="segmento">
            <div class="segmento-titulo titulo-conteudo-filtros"> Segmento </div>
            <PDropDown
            class="segmento-input input-label"
            :filter="true"
            optionLabel="descricao"
            optionValue="clienteTipoId"
            :options="SegmentoArray"
            placeholder="Selecione"
            v-model="objFiltro.Segmento"
            >
            </PDropDown>
          </div>

          <div class="perfil-material">
            <div class="perfil-material-titulo titulo-conteudo-filtros"> Perfil Material </div>
            <PDropDown
            class="perfil-material-input input-label"
            :filter="true"
            optionLabel="text"
            optionValue="value"
            :options="PerfilMaterialArray"
            v-model="objFiltro.perfilMaterialSwitch"
            placeholder="Selecione"
            >
            </PDropDown>
          </div>

          <div class="potencial-cliente">
            <div class="potencial-cliente-titulo titulo-conteudo-filtros"> Potencial do Cliente </div>
            <PDropDown
            class="potencial-cliente-input input-label"
            :filter="true"
            optionLabel="text"
            optionValue="value"
            :options="PotencialClienteArray"
            v-model="objFiltro.potencialClienteSwitch"
            placeholder="Selecione"
            >
            </PDropDown>
          </div>

          <div class="checkbox-filtros">
            <div class="parametros-titulo titulo-conteudo-filtros"> Outros Parâmetros </div>
            <div class="parametros-checkboxes">
                <div class="consultar-cnpj input-checkbox">
                  <PCheckBox :binary="true" id="consultar-cnpj" class="checkbox-consultar-cnpj" v-model="objFiltro.DadosBaseCNPJ"></PCheckBox>
                  <label class="consultarCnpj label-checkbox" for="consultar-cnpj" > Consultar dados da base do CNPJ </label>
                </div>
                <div class="consultar-dados input-checkbox">
                  <PCheckBox :binary="true" id="consultar-dados"  class="checkbox-consultas" v-model="objFiltro.DadosClienteAgrupador"></PCheckBox>
                  <label class="consultarDados label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
                </div>
            </div>
          </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="15px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        @click="Grid()"
        >
        BUSCAR
        </g-button>
      </div>
    </g-card>

    <g-card v-if="pt1" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!pt1" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      Titulo="Dados do Cliente"
      altura="auto"
      :colunas="Colunas"
      :Paginacao="true"
      :valores="ClienteArray"
      :NumeroLinhas="100"
      :Filtros="Filtro"
      :numeroBotoesAcao="3"
      :FiltrosEspecificos="true"
      :rowEditor="true"
      v-on:duploClickLinha="direcionaDetalhes"
      :Editavel="true"
      TextEditar="Altera o cliente"
      :Imprimivel="true"
      v-on:editar="editar"
      :campoAgrupador="'empresaCliente'"
      :campoExibicaoGrupo="'empresaCliente'"
      v-on:clickImprimir="imprimir"
      ></g-data-table>
    </g-card>
  </div>
  <g-pdf
    :pdfFloat="false"
    :NovaGuia="true"
    :executar="executarvisualizacao"
  >
    <div class="render" v-if="renderiza">
      <div>
          <div class="container-logo">
            <img class="logo-login" src="@/assets/imgs/grupo_jauense_logo.svg">
          </div>
        </div>
      <PDFClienteInformacao
        v-on:termino="gerarPdf"
        :clienteInformado="this.ClienteClicado"
        :empresaInformada="this.UnidadeSelecionada"
      >
      </PDFClienteInformacao>
    </div>
  </g-pdf>
</template>

<script>
import Cliente from "./ClienteConsulta.js";

export default Cliente;
</script>

<style scoped>
.container-logo{
  padding: 30px 30px 10px 53px;
}
.estado-cidade {
  width: 100%;
}

@media (min-width: 310px) {
.estado-cidade {
  display: grid;
  grid-template-columns: 30% auto;
  grid-template-rows: auto;
  grid-column-gap: 20px;
  align-items: flex-end;
}
}

@media (min-width: 368px) {}

@media (min-width: 600px) {
.consulta-clientes-conteudo {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(8, auto);
  grid-column-gap: 20px;
}

.campo-unidade { grid-area: 1 / 1 / 2 / 3; }
.cnpj { grid-area: 2 / 1 / 3 / 2; }
.codigo-cliente { grid-area: 2 / 2 / 3 / 3; }
.razao-social { grid-area: 3 / 1 / 4 / 2; }
.nome-reduzido { grid-area: 3 / 2 / 4 / 3; }
.estado-cidade { grid-area: 4 / 1 / 5 / 3; }
.data-cadastro { grid-area: 5 / 1 / 6 / 3; }
.situacao { grid-area: 6 / 1 / 7 / 2; }
.segmento { grid-area: 6 / 2 / 7 / 3; }
.perfil-material { grid-area: 7 / 1 / 8 / 2; }
.potencial-cliente { grid-area: 7 / 2 / 8 / 3; }
.parametros { grid-area: 8 / 1 / 9 / 3; }
}

@media (min-width: 801px) {
.consulta-clientes-conteudo {
  grid-template-rows: repeat(6, auto);
}

.campo-unidade { grid-area: 1 / 1 / 2 / 2; }
.cnpj { grid-area: 1 / 2 / 2 / 3; }
.codigo-cliente { grid-area: 2 / 1 / 3 / 2; }
.razao-social { grid-area: 2 / 2 / 3 / 3; }
.nome-reduzido { grid-area: 3 / 1 / 4 / 2; }
.estado-cidade { grid-area: 3 / 2 / 4 / 3; }
.data-cadastro { grid-area: 4 / 1 / 5 / 2; }
.situacao { grid-area: 4 / 2 / 5 / 3; }
.segmento { grid-area: 5 / 1 / 6 / 2; }
.perfil-material { grid-area: 5 / 2 / 6 / 3; }
.potencial-cliente { grid-area: 6 / 1 / 7 / 2; }
.parametros { grid-area: 6 / 2 / 7 / 3;}
}

@media (min-width: 1025px) {
.consulta-clientes-conteudo {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(5, auto);
}

.codigo-cliente { grid-area: 1 / 3 / 2 / 4; }
.razao-social { grid-area: 2 / 1 / 3 / 2; }
.nome-reduzido { grid-area: 2 / 2 / 3 / 3; }
.estado-cidade { grid-area: 2 / 3 / 3 / 4; }
.data-cadastro { grid-area: 3 / 1 / 4 / 2; }
.situacao { grid-area: 3 / 2 / 4 / 3; }
.segmento { grid-area: 3 / 3 / 4 / 4; }
.perfil-material { grid-area: 4 / 1 / 5 / 2; }
.potencial-cliente { grid-area: 4 / 2 / 5 / 3; }
.parametros { grid-area: 4 / 3 / 5 / 4; }
}

@media (min-width: 1600px) {
.consulta-clientes-conteudo {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, auto);
}

.razao-social { grid-area: 1 / 4 / 2 / 5; }
.nome-reduzido { grid-area: 2 / 1 / 3 / 2; }
.estado-cidade { grid-area: 2 / 2 / 3 / 3; }
.data-cadastro { grid-area: 2 / 3 / 3 / 4; }
.situacao { grid-area: 2 / 4 / 3 / 5; }
.segmento { grid-area: 3 / 1 / 4 / 2; }
.perfil-material { grid-area: 3 / 2 / 4 / 3; }
.potencial-cliente { grid-area: 3 / 3 / 4 / 4; }
.parametros { grid-area: 3 / 4 / 4 / 5; }
}

@media (min-width: 1500px) {}
</style>